/*
 * @Author: your name
 * @Date: 2021-05-12 09:28:02
 * @LastEditTime: 2021-05-14 14:19:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /me-short-version/src/http/Use_electricity_monitor.js
 */
import $http from "./http";

// 获取采集点
export const getUnitPointList = data => {
    return $http.post("/collect/common/getUnitPointList", data);
};
// 获得系统时间
export const getSysDate = data => {
    return $http.post("/collect/common/getSysDate", data);
};
// 电量分析接口
// 通过日期与采集点id获取用电量
export const getElecInfo = data => {
    return $http.post("/collect/monitor/getElecInfo", data);
};
export const getUnitElecInfo = data => {
    return $http.post("collect/monitor/getElecTreeUnitInfo", data);
};
export const getLyElecInfo = data => {
    return $http.post("collect/lymonitor/getElecInfo", data);
};
export const getGasDayList = data => {
    return $http.post("collect/lymonitor/getGasDayList", data);
};
// 瞬时量趋势分析接口
export const getRealTimeData = data => {
    return $http.post("/collect/monitor/getRealTimeData", data);
};

//
export const getMonthPower = data => {
    return $http.post("/collect/monitor/getMonthPower", data);
};

//
export const getYearPower = data => {
    return $http.post("/collect/monitor/getYearPower", data);
};

export const getLoad = data => {
    return $http.post("/collect/customer_load/getLoad", data);
};

export const getDayLoad = data => {
    return $http.post("/collect/customer_load/getDayLoad", data);
};

export const getMonthLoad = data => {
    return $http.post("/collect/customer_load/getMonthLoad", data);
};

export const getPointColumnKinds = data => {
    return $http.post("/collect/monitor/getPointColumnKinds", data);
};

export const getWaterInfo = data => {
    return $http.post("/collect/monitor/getWaterInfo", data);
};
export const getWaterList = data => {
    return $http.post("/collect/monitor/getWaterList", data);
};
export const getElecList = data => {
    return $http.post("/collect/monitor/getElecList", data);
};
export const getElecUnitTreeList = data => {
    return $http.post("/collect/monitor/getElecUnitTreeList", data);
};

export const getCommonPointList = data => {
    return $http.post("/collect/common/getCommonPointList", data);
};

export const getPointClassList = data => {
    return $http.post("/collect/monitor/getPointClassList", data);
};

export const getCommonInfo = data => {
    return $http.post("/collect/monitor/getCommonInfo", data);
};

// 获取年月的数据
export const getCommonList = data => {
    return $http.post("/collect/monitor/getCommonList", data);
};

export const getCommonTreeUnitInfo = data => {
    return $http.post("collect/monitor/getCommonTreeUnitInfo", data);
};
